var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Arrow } from "../Arrow";
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleExpandCollapse = function (e) {
            _this.setState(function (prevstate) { return ({ isExpanded: !prevstate.isExpanded }); });
            e.stopPropagation();
        };
        _this.state = { isExpanded: false };
        return _this;
    }
    Dropdown.prototype.renderItems = function () {
        return {
            desktop: this.props.data.map(this.renderItemDesktop, this),
            mobile: this.props.data.map(this.renderItemMobile, this)
        };
    };
    Dropdown.prototype.renderItemDesktop = function (item) {
        var _this = this;
        return (React.createElement("div", { "data-selected": item.isSelected, key: item.id, onClick: function () { _this.props.selectItem(item.id); }, "data-id": item.id, className: "rj-dropdown__item" }, item.text));
    };
    Dropdown.prototype.renderItemMobile = function (item) {
        return (React.createElement("option", { selected: item.isSelected, value: item.id, key: item.id }, item.text));
    };
    Dropdown.prototype.render = function () {
        var _this = this;
        var _a = this.props, blockName = _a.blockName, defaultText = _a.defaultText, data = _a.data;
        var label = data.find(function (x) { return x.isSelected; }) ? data.find(function (x) { return x.isSelected; }).text : defaultText;
        return (React.createElement("div", { className: "rj-dropdown rj-" + blockName + "__dropdown", onClick: function (e) { _this.toggleExpandCollapse(e); } },
            React.createElement("span", { className: "rj-dropdown__active-item" }, label),
            React.createElement(Arrow, { direction: "down" }),
            React.createElement("div", { className: "rj-dropdown__html" }, this.state.isExpanded && this.renderItems().desktop),
            React.createElement("select", { onChange: function (e) { _this.props.selectItem(e.target.value); }, className: "rj-dropdown__native" },
                React.createElement("option", { selected: true, disabled: true, hidden: true }, label),
                this.renderItems().mobile)));
    };
    return Dropdown;
}(React.Component));
export { Dropdown };
//# sourceMappingURL=Dropdown.js.map